import React from "react";
import ReactDOM from "react-dom/client";
import {
  createRouter,
  RouterProvider,
  ToOptions,
} from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";
import "./index.css";
import "@mantine/core/styles.css";
import "@mantine/dates/styles.css";
import "@mantine/charts/styles.css";
import { client } from "./api/client.gen";
import storage from "./pkg/storage";
import { TOKEN_KEY } from "./pkg/constants";
import { getApiHost, getApiScheme } from "./pkg/loader";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { NotificationProvider } from "./contexts/NotificationContext";
import { ApiResponseError } from "./pkg/error";
import { MantineProvider } from "@mantine/core";
import { I18nProvider } from "@lingui/react";
import { i18n } from "@lingui/core";
import { defaultLocale, dynamicActivate } from "./i18n";
const router = createRouter({ routeTree });

const token = storage.get(TOKEN_KEY) || "";

client.setConfig({
  baseUrl: `${getApiScheme()}://${getApiHost()}`,
});

client.interceptors.response.use(async (response) => {
  const statusCategory = response?.status.toString()[0];

  switch (statusCategory) {
    case "4": {
      throw new ApiResponseError(response);
    }
    case "5":
      throw new ApiResponseError(response);
  }

  return response;
});

client.interceptors.request.use((request) => {
  request.headers.set("Authorization", `Bearer ${token}`);
  return request;
});

(async () => {
  await dynamicActivate(defaultLocale);
})();

// Register the router instance for type safety
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
  interface HistoryState {
    key?: string;
    lastFullPath?: ToOptions["to"];
    lastParams?: Record<string, any>;
  }
}

export const queryClient = new QueryClient();

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <NotificationProvider>
        <MantineProvider>
            <I18nProvider i18n={i18n}>
              <RouterProvider router={router} />
            </I18nProvider>
        </MantineProvider>
      </NotificationProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
